import Phaser from 'phaser'
import { THEME, hex } from '../../../kit/theme'

/** Standard Hitz button: rounded, big touch target, small press feedback. `secondary` = outlined. */
export function button(scene: Phaser.Scene, x: number, y: number, label: string, onClick: () => void, opts: { w?: number; secondary?: boolean; sub?: string } = {}) {
  const w = opts.w ?? 440, h = opts.sub ? 130 : 110
  const bg = scene.add.rectangle(0, 0, w, h, hex(opts.secondary ? 'panel' : 'accent'))
  bg.setStrokeStyle(4, hex(opts.secondary ? 'stone' : 'accent'))
  const color = opts.secondary ? THEME.colors.text : THEME.colors.accentDark
  const text = scene.add.text(0, opts.sub ? -16 : 0, label, { fontFamily: THEME.font.family, fontSize: '44px', color, fontStyle: 'bold' }).setOrigin(0.5)
  const parts: Phaser.GameObjects.GameObject[] = [bg, text]
  if (opts.sub) parts.push(scene.add.text(0, 30, opts.sub, { fontFamily: THEME.font.family, fontSize: '26px', color: opts.secondary ? THEME.colors.textDim : THEME.colors.accentDark }).setOrigin(0.5))
  const c = scene.add.container(x, y, parts).setSize(w, h).setInteractive({ useHandCursor: true })
  c.on('pointerdown', () => c.setScale(0.96))
  c.on('pointerout', () => c.setScale(1))
  c.on('pointerup', () => { c.setScale(1); onClick() })
  return c
}
